export const consulting = {
  is: {
    title: "Fagleg ráðgjöf fyrir stafræna framtíð",
    description: "Við hjálpum fyrirtækjum að ná árangri í stafrænum heimi með sérfræðiþekkingu og reynslu.",
    featuresTitle: "Alhliða ráðgjöf fyrir þitt fyrirtæki",
    featuresDescription: "Við bjóðum upp á fjölbreytta ráðgjöf sem hjálpar þér að ná markmiðum þínum",
    features: {
      strategy: {
        title: "Stefnumótun",
        description: "Við hjálpum þér að móta skýra stafræna stefnu fyrir þitt fyrirtæki."
      },
      marketAnalysis: {
        title: "Markaðsgreining",
        description: "Ítarleg greining á markaðnum og samkeppnisaðilum."
      },
      userExperience: {
        title: "Notendaupplifun",
        description: "Ráðgjöf um bestu leiðir til að bæta notendaupplifun."
      },
      performanceMeasurement: {
        title: "Árangursmælingar",
        description: "Skilgreining á lykilmælikvörðum og eftirfylgni."
      },
      digitalTransformation: {
        title: "Stafræn umbreyting",
        description: "Aðstoð við stafræna umbreytingu fyrirtækja."
      },
      innovation: {
        title: "Nýsköpun",
        description: "Ráðgjöf um nýsköpun og tækifæri í stafrænni þróun."
      }
    },
    process: {
      title: "Ráðgjafaferlið okkar",
      description: "Við fylgjum skilvirku ferli til að tryggja árangursríka ráðgjöf",
      steps: {
        analysis: {
          title: "Greining á stöðu",
          description: "Við byrjum á að greina núverandi stöðu og skilgreina helstu áskoranir og tækifæri."
        },
        goals: {
          title: "Markmiðasetning",
          description: "Við setjum skýr og mælanleg markmið fyrir verkefnið."
        },
        plan: {
          title: "Aðgerðaáætlun",
          description: "Við útbúum ítarlega aðgerðaáætlun með skýrum skrefum og tímalínu."
        },
        implementation: {
          title: "Innleiðing og eftirfylgni",
          description: "Við aðstoðum við innleiðingu og fylgjum verkefninu eftir til að tryggja árangur."
        }
      }
    },
    cta: {
      title: "Viltu ræða þitt verkefni?",
      description: "Við erum tilbúin að hjálpa þér að ná þínum markmiðum með faglegri ráðgjöf og reynslu",
      button: "Bóka fund"
    }
  },
  en: {
    title: "Professional Consulting for a Digital Future",
    description: "We help businesses succeed in the digital world with expertise and experience.",
    featuresTitle: "Comprehensive Consulting for Your Business",
    featuresDescription: "We offer diverse consulting services that help you achieve your goals",
    features: {
      strategy: {
        title: "Strategy Development",
        description: "We help you develop a clear digital strategy for your business."
      },
      marketAnalysis: {
        title: "Market Analysis",
        description: "Detailed analysis of the market and competitors."
      },
      userExperience: {
        title: "User Experience",
        description: "Advice on best practices to improve user experience."
      },
      performanceMeasurement: {
        title: "Performance Measurement",
        description: "Definition of key performance indicators and follow-up."
      },
      digitalTransformation: {
        title: "Digital Transformation",
        description: "Assistance with digital transformation of businesses."
      },
      innovation: {
        title: "Innovation",
        description: "Consulting on innovation and opportunities in digital development."
      }
    },
    process: {
      title: "Our Consulting Process",
      description: "We follow an efficient process to ensure successful consulting",
      steps: {
        analysis: {
          title: "Situation Analysis",
          description: "We begin by analyzing the current situation and identifying key challenges and opportunities."
        },
        goals: {
          title: "Goal Setting",
          description: "We set clear and measurable goals for the project."
        },
        plan: {
          title: "Action Plan",
          description: "We create a detailed action plan with clear steps and timeline."
        },
        implementation: {
          title: "Implementation and Follow-up",
          description: "We assist with implementation and follow the project to ensure success."
        }
      }
    },
    cta: {
      title: "Want to discuss your project?",
      description: "We are ready to help you achieve your goals with professional consulting and experience",
      button: "Book a meeting"
    }
  },
  es: {
    title: "Consultoría Profesional para un Futuro Digital",
    description: "Ayudamos a las empresas a tener éxito en el mundo digital con experiencia y conocimientos especializados.",
    featuresTitle: "Consultoría Integral para su Empresa",
    featuresDescription: "Ofrecemos diversos servicios de consultoría que le ayudan a alcanzar sus objetivos",
    features: {
      strategy: {
        title: "Desarrollo de Estrategia",
        description: "Le ayudamos a desarrollar una estrategia digital clara para su empresa."
      },
      marketAnalysis: {
        title: "Análisis de Mercado",
        description: "Análisis detallado del mercado y la competencia."
      },
      userExperience: {
        title: "Experiencia de Usuario",
        description: "Asesoramiento sobre mejores prácticas para mejorar la experiencia del usuario."
      },
      performanceMeasurement: {
        title: "Medición de Rendimiento",
        description: "Definición de indicadores clave de rendimiento y seguimiento."
      },
      digitalTransformation: {
        title: "Transformación Digital",
        description: "Asistencia en la transformación digital de empresas."
      },
      innovation: {
        title: "Innovación",
        description: "Consultoría sobre innovación y oportunidades en desarrollo digital."
      }
    },
    process: {
      title: "Nuestro Proceso de Consultoría",
      description: "Seguimos un proceso eficiente para garantizar una consultoría exitosa",
      steps: {
        analysis: {
          title: "Análisis de Situación",
          description: "Comenzamos analizando la situación actual e identificando desafíos y oportunidades clave."
        },
        goals: {
          title: "Establecimiento de Objetivos",
          description: "Establecemos objetivos claros y medibles para el proyecto."
        },
        plan: {
          title: "Plan de Acción",
          description: "Creamos un plan de acción detallado con pasos claros y cronograma."
        },
        implementation: {
          title: "Implementación y Seguimiento",
          description: "Asistimos con la implementación y seguimos el proyecto para garantizar el éxito."
        }
      }
    },
    cta: {
      title: "¿Quiere discutir su proyecto?",
      description: "Estamos listos para ayudarle a alcanzar sus objetivos con consultoría profesional y experiencia",
      button: "Reservar una reunión"
    }
  },
  da: {
    title: "Professionel Rådgivning til en Digital Fremtid",
    description: "Vi hjælper virksomheder med at få succes i den digitale verden med ekspertise og erfaring.",
    featuresTitle: "Omfattende Rådgivning til Din Virksomhed",
    featuresDescription: "Vi tilbyder forskellige rådgivningstjenester, der hjælper dig med at nå dine mål",
    features: {
      strategy: {
        title: "Strategiudvikling",
        description: "Vi hjælper dig med at udvikle en klar digital strategi for din virksomhed."
      },
      marketAnalysis: {
        title: "Markedsanalyse",
        description: "Detaljeret analyse af markedet og konkurrenter."
      },
      userExperience: {
        title: "Brugeroplevelse",
        description: "Rådgivning om bedste praksis for at forbedre brugeroplevelsen."
      },
      performanceMeasurement: {
        title: "Resultatmåling",
        description: "Definition af nøgleresultatindikatorer og opfølgning."
      },
      digitalTransformation: {
        title: "Digital Transformation",
        description: "Assistance med digital transformation af virksomheder."
      },
      innovation: {
        title: "Innovation",
        description: "Rådgivning om innovation og muligheder inden for digital udvikling."
      }
    },
    process: {
      title: "Vores Rådgivningsproces",
      description: "Vi følger en effektiv proces for at sikre vellykket rådgivning",
      steps: {
        analysis: {
          title: "Situationsanalyse",
          description: "Vi begynder med at analysere den nuværende situation og identificere nøgleudfordringer og muligheder."
        },
        goals: {
          title: "Målsætning",
          description: "Vi fastsætter klare og målbare mål for projektet."
        },
        plan: {
          title: "Handlingsplan",
          description: "Vi opretter en detaljeret handlingsplan med klare trin og tidsplan."
        },
        implementation: {
          title: "Implementering og Opfølgning",
          description: "Vi hjælper med implementering og følger projektet for at sikre succes."
        }
      }
    },
    cta: {
      title: "Vil du diskutere dit projekt?",
      description: "Vi er klar til at hjælpe dig med at nå dine mål med professionel rådgivning og erfaring",
      button: "Book et møde"
    }
  }
};